<template>
  <div class="mb-3">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('bold')"
          fab
          :color="editor.isActive('bold') ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleBold()
              .run()
          "
          :class="{ 'is-active': editor.isActive('bold'), 'pa-0 ma-1': true }"
        >
          <v-icon>mdi-format-bold</v-icon>
        </v-btn>
      </template>
      <span>bold</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('italic')"
          fab
          :color="editor.isActive('italic') ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleItalic()
              .run()
          "
          :class="{ 'is-active': editor.isActive('italic'), 'pa-0 ma-1': true }"
        >
          <v-icon>mdi-format-italic</v-icon>
        </v-btn>
      </template>
      <span>italic</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('strike')"
          fab
          :color="editor.isActive('strike') ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleStrike()
              .run()
          "
          :class="{ 'is-active': editor.isActive('strike'), 'pa-0 ma-1': true }"
        >
          <v-icon>mdi-format-strikethrough</v-icon>
        </v-btn>
      </template>
      <span>strike</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('code')"
          fab
          :color="editor.isActive('code') ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleCode()
              .run()
          "
          :class="{ 'is-active': editor.isActive('code'), 'pa-0 ma-1': true }"
        >
          <v-icon>mdi-code-tags</v-icon>
        </v-btn>
      </template>
      <span>code</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('paragraph')"
          fab
          :color="editor.isActive('paragraph') ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .setParagraph()
              .run()
          "
          :class="{
            'is-active': editor.isActive('paragraph'),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-paragraph</v-icon>
        </v-btn>
      </template>
      <span>paragraph</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('highlight')"
          fab
          :color="editor.isActive('highlight') ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleHighlight()
              .run()
          "
          :class="{
            'is-active': editor.isActive('highlight'),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-color-highlight</v-icon>
        </v-btn>
      </template>
      <span>highlight</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('heading', { level: 1 })"
          fab
          :color="editor.isActive('heading', { level: 1 }) ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 1 })
              .run()
          "
          :class="{
            'is-active': editor.isActive('heading', { level: 1 }),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-header-1</v-icon>
        </v-btn>
      </template>
      <span>heading 1</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('heading', { level: 2 })"
          fab
          :color="editor.isActive('heading', { level: 2 }) ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 2 })
              .run()
          "
          :class="{
            'is-active': editor.isActive('heading', { level: 2 }),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-header-2</v-icon>
        </v-btn>
      </template>
      <span>heading 2</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('heading', { level: 3 })"
          fab
          :color="editor.isActive('heading', { level: 3 }) ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 3 })
              .run()
          "
          :class="{
            'is-active': editor.isActive('heading', { level: 3 }),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-header-3</v-icon>
        </v-btn>
      </template>
      <span>heading 3</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('heading', { level: 4 })"
          fab
          :color="editor.isActive('heading', { level: 4 }) ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 4 })
              .run()
          "
          :class="{
            'is-active': editor.isActive('heading', { level: 4 }),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-header-4</v-icon>
        </v-btn>
      </template>
      <span>heading 4</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('heading', { level: 5 })"
          fab
          :color="editor.isActive('heading', { level: 5 }) ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 5 })
              .run()
          "
          :class="{
            'is-active': editor.isActive('heading', { level: 5 }),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-header-5</v-icon>
        </v-btn>
      </template>
      <span>heading 5</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('heading', { level: 6 })"
          fab
          :color="editor.isActive('heading', { level: 6 }) ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 6 })
              .run()
          "
          :class="{
            'is-active': editor.isActive('heading', { level: 6 }),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-header-6</v-icon>
        </v-btn>
      </template>
      <span>heading 6</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('bulletList')"
          :color="editor.isActive('bulletList') ? 'orange' : ''"
          fab
          @click="
            editor
              .chain()
              .focus()
              .toggleBulletList()
              .run()
          "
          :class="{
            'is-active': editor.isActive('bulletList'),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-btn>
      </template>
      <span>bullet list</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('orderedList')"
          fab
          :color="editor.isActive('orderedList') ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleOrderedList()
              .run()
          "
          :class="{
            'is-active': editor.isActive('orderedList'),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-list-numbered</v-icon>
        </v-btn>
      </template>
      <span>ordered list</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('codeBlock')"
          fab
          :color="editor.isActive('codeBlock') ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleCodeBlock()
              .run()
          "
          :class="{
            'is-active': editor.isActive('codeBlock'),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-code-braces-box</v-icon>
        </v-btn>
      </template>
      <span>code block</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive('blockquote')"
          fab
          :color="editor.isActive('blockquote') ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .toggleBlockquote()
              .run()
          "
          :class="{
            'is-active': editor.isActive('blockquote'),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-quote-close</v-icon>
        </v-btn>
      </template>
      <span>block quote</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive({ textAlign: 'left' })"
          fab
          :color="editor.isActive({ textAlign: 'left' }) ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .setTextAlign('left')
              .run()
          "
          :class="{
            'is-active': editor.isActive({ textAlign: 'left' }),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-align-left</v-icon>
        </v-btn>
      </template>
      <span>align left</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive({ textAlign: 'center' })"
          fab
          :color="editor.isActive({ textAlign: 'center' }) ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .setTextAlign('center')
              .run()
          "
          :class="{
            'is-active': editor.isActive({ textAlign: 'center' }),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-align-center</v-icon>
        </v-btn>
      </template>
      <span>align center</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive({ textAlign: 'right' })"
          fab
          :color="editor.isActive({ textAlign: 'right' }) ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .setTextAlign('right')
              .run()
          "
          :class="{
            'is-active': editor.isActive({ textAlign: 'right' }),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-align-right</v-icon>
        </v-btn>
      </template>
      <span>align right</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          :outlined="!editor.isActive({ textAlign: 'justify' })"
          fab
          :color="editor.isActive({ textAlign: 'justify' }) ? 'orange' : ''"
          @click="
            editor
              .chain()
              .focus()
              .setTextAlign('justify')
              .run()
          "
          :class="{
            'is-active': editor.isActive({ textAlign: 'justify' }),
            'pa-0 ma-1': true,
          }"
        >
          <v-icon>mdi-format-align-justify</v-icon>
        </v-btn>
      </template>
      <span>align justify</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          fab
          outlined
          class="pa-0 ma-1"
          @click="
            editor
              .chain()
              .focus()
              .setHorizontalRule()
              .run()
          "
        >
          ----
        </v-btn>
      </template>
      <span>horizontal line</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          fab
          outlined
          class="pa-0 ma-1"
          @click="
            editor
              .chain()
              .focus()
              .setHardBreak()
              .run()
          "
        >
          <v-icon>mdi-format-page-break</v-icon>
        </v-btn>
      </template>
      <span>page break</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          fab
          outlined
          class="pa-0 ma-1"
          @click="
            editor
              .chain()
              .focus()
              .undo()
              .run()
          "
        >
          <v-icon>mdi-undo</v-icon>
        </v-btn>
      </template>
      <span>undo</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          fab
          outlined
          @click="
            editor
              .chain()
              .focus()
              .redo()
              .run()
          "
        >
          <v-icon>mdi-redo</v-icon>
        </v-btn>
      </template>
      <span>redo</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-small
          fab
          outlined
          class="menubar__v-btn pa-0 ma-1"
          @click="
            () => {
              $emit('update:modal', true);
            }
          "
        >
          <svg width="14" height="14" viewBox="0 0 58 58">
            <path
              d="M57 6H1a1 1 0 0 0-1 1v44c0 .6.4 1 1 1h56c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zm-1 44H2V8h54v42z"
            />
            <path
              d="M16 28.1A5.6 5.6 0 1 0 16 17 5.6 5.6 0 0 0 16 28zm0-9.1a3.6 3.6 0 1 1 0 7.1 3.6 3.6 0 0 1 0-7.1zM7 46c.2 0 .5 0 .7-.2L24 31.4l10.3 10.3a1 1 0 1 0 1.4-1.4l-4.8-4.8 9.2-10 11.2 10.2a1 1 0 0 0 1.4-1.4l-12-11a1 1 0 0 0-1.4 0l-9.8 10.8-4.8-4.8a1 1 0 0 0-1.3 0l-17 15A1 1 0 0 0 7 46z"
            />
          </svg>
        </v-btn>
      </template>
      <span>insert image</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: ['editor', 'modal'],
};
</script>
